import * as ActionTypes from '../ActionTypes';

const initialState = {
    ats_designation_options: [],
    isLoading: false,
};

const AtsDesignationReducer = function (state = initialState, action) {
    switch (action.type) {
        case ActionTypes.ATS_DESIGNATION_GET_REQUEST:
            return {
                ...state,
                isLoading: true,
                ats_designation_options: "",
            };
        case ActionTypes.ATS_DESIGNATION_GET_SUCCESS:
            return {
                ...state,
                success_message: action.payload.message,
                error: action.payload.has_error,
                isLoading: false,
                ats_designation_options: action.payload?.data?.data
            };
        case ActionTypes.ATS_DESIGNATION_ADD_REQUEST:
            return {
                ...state,
                isLoading: true,
                error: false,
                success: false,
            };
        case ActionTypes.ATS_DESIGNATION_ADD_SUCCESS:
            return {
                ...state,
                isLoading: false,
                success: true,
                successMessage: action.payload?.message,
                ats_designation_options: action.payload?.data?.data
            };
        case ActionTypes.ATS_DESIGNATION_ADD_ERROR:
            return {
                ...state,
                isLoading: false,
                error: action?.payload?.hasError,
                errorMessage: action.payload?.data?.error?.[0]?.message
            };
        case ActionTypes.ATS_DESIGNATION_UPDATE_REQUEST:
            return {
                ...state,
                isLoading: true,
                error: false,
                success: false,
            };
        case ActionTypes.ATS_DESIGNATION_UPDATE_SUCCESS:
            return {
                ...state,
                isLoading: false,
                success: true,
                successMessage: action.payload?.message,
                ats_designation_options: action.payload?.data?.data
            };
        case ActionTypes.ATS_DESIGNATION_UPDATE_ERROR:
            return {
                ...state,
                isLoading: false,
                error: action?.payload?.hasError,
                errorMessage: action.payload?.data?.error?.[0]?.message
            };
        case ActionTypes.ATS_DESIGNATION_DELETE_REQUEST:
            return {
                ...state,
                isLoading: true,
                error: false,
                success: false,
            };
        case ActionTypes.ATS_DESIGNATION_DELETE_SUCCESS:
            return {
                ...state,
                isLoading: false,
                success: true,
                successMessage: action.payload?.message,
                ats_designation_options: action.payload?.data?.data
            };
        case ActionTypes.ATS_DESIGNATION_DELETE_ERROR:
            return {
                ...state,
                isLoading: false,
                error: action?.payload?.hasError,
                errorMessage: action.payload?.data?.error?.[0]?.message
            };
        default:
            return state;
    }
}

export default AtsDesignationReducer;